import React, { useState, useEffect, useRef } from 'react';
import { 
  HelpCircle,
  Eye, AlertCircle,
  Calendar, User, DollarSign,
  FileText, BookOpen, Calculator,
  Hourglass,
  CheckSquare,X
} from 'lucide-react';
import { formatearFechaCompleta} from '../../../utils/utils';
import { BotonCopiar } from '../../../components/ButtonCopy';
import { procesarMensajeSolicitud } from '../../../utils/mensajes_utils';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { useNavigate } from 'react-router-dom';
import { useDetalleSolicitudModel } from '../../../modelos/Solicitudes/modeloSolicitud';
import { obtenerInfoCotizaciones } from './components/FuncionSolicitudes';
import BotonGenerarCotizacion from './components/BotonGenerarCotizacionTesis';
import { useDialog } from '../../../components/Dialogs/Dialogprovider';
import { useisUserAdmin, useisUserCliente, useisUserTutor } from '../../../config/unificacion';
import { useUsers } from '../../../metodos/userContext';
import { GeneralRoutes} from '../../../utils/navigator';

const CardSolicitud = ({
  solicitud,
  onRechazar,
}) => {
  //menu abierto
  const menuRef = useRef(null);
  const [menuAbierto, setMenuAbierto] = useState(null);
  const { configuracion} = useConfiguracion();    
  const navigate = useNavigate();
  const {enviarNotificacionSolciitud, actualizarSolicitud,rechazarSolicitud} = useDetalleSolicitudModel();
  const { showPrompt } = useDialog();

  //ROLES
  const { usuario, loadingUsuario, errorUsuario } = useUsers();
  const isAdmin = useisUserAdmin(usuario);
  const isTutor = useisUserTutor(usuario);
  const isCliente = useisUserCliente(usuario);

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuAbierto(null);
    }
  };

  // Solo agregar el listener si el menú está abierto
  if (menuAbierto) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  // Cleanup
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
  }, [menuAbierto]);


  //Filtro por estado, Disponibles - A pasar precio - Esperando
  const obtenerEstadoDisponibilidad = (solicitud) => {
    const estadoLower = solicitud.Estado;
    
    // Veiricar cotizaciones
    const tieneCotizacionesConPrecio = solicitud.cotizaciones && 
      solicitud.cotizaciones.some(cotizacion => {
        const precio = cotizacion.cotizacion || 0;
        return precio > 0;
    });
    
    if (estadoLower == "ESPERANDO") {
      return 'esperando';
    }

    if(estadoLower === "DISPONIBLE"){

      if(tieneCotizacionesConPrecio){
        return 'a_pasar_precio';
      }

      return 'disponible';

    }
     
    // Por defecto, considerar disponible
    return 'disponible';
  };

  //Prioridad de trabajo
  const calcularPrioridad = (fechaEntrega) => {
    const ahora = new Date();
    const entrega = new Date(fechaEntrega);
    const horasRestantes = (entrega - ahora) / (1000 * 60 * 60);

    if (horasRestantes < 0) return { 
      tipo: 'vencida', 
      label: 'Vencida', 
      color: 'from-gray-500 to-gray-600' };
    if (horasRestantes <= 24) return { 
      tipo: 'urgente', 
      label: '< 24hr', 
      color: 'from-red-500 to-red-600' };
    if (horasRestantes <= 36) return { 
      tipo: 'medio', 
      label: '< dia y medio', 
      color: 'from-yellow-500 to-orange-500' };
    if (horasRestantes <= 48) return { 
      tipo: 'normal', 
      label: '< 2 dias', 
      color: 'from-green-500 to-green-600' };
    return { 
      tipo: 'normal', 
      label: `${Math.ceil(horasRestantes / 24)} días`, 
      color: 'from-green-500 to-green-600' };
  };
  //Colores para servicios, icono y label
  const obtenerInfoServicio = (servicio) => {
    const servicioLower = servicio;
    
    const mapeoServicios = {
      'PARCIAL': { 
        icon: <FileText size={20} />, 
        color: 'from-green-500 to-green-600', 
        label: 'Parcial' },
      'TALLER': { 
        icon: <FileText size={20} />, 
        color: 'from-blue-500 to-blue-600', 
        label: 'Taller' },
      'TESIS': { 
        icon: <BookOpen size={20} />, 
        color: 'from-purple-500 to-purple-600', 
        label: 'Tesis' },
      'QUIZ': { 
        icon: <Calculator size={20} />, 
        color: 'from-green-500 to-green-600', 
        label: 'Quiz' },
      'CLASES PERSONALIZADAS': { 
        icon: <Calculator size={20} />, 
        color: 'from-green-500 to-green-600', 
        label: 'Clase personalizada' },
    };

    return mapeoServicios[servicioLower] || { 
      icon: <FileText size={20} />, 
      color: 'from-gray-500 to-gray-600', 
      label: servicio 
    };
  };

  //calcular tiempo
  const formatearTiempoTranscurrido = (fechaPublicacion) => {
  const { dias, horas, minutos, totalHoras } = calcularTiempoPublicado(fechaPublicacion);
  
  if (totalHoras < 1) {
    return `${minutos}m`;
  } else if (totalHoras < 24) {
    return `${horas}h ${minutos}m`;
  } else {
    return `${dias}d ${horas}h`;
  }
  };
  const calcularTiempoPublicado = (fechaPublicacion) =>{
    const ahora = new Date();
    const publicacion = new Date(fechaPublicacion);
    const tiempoTranscurrido = ahora - publicacion;

     const dias = Math.floor(tiempoTranscurrido / (1000 * 60 * 60 * 24));
    const horas = Math.floor((tiempoTranscurrido % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutos = Math.floor((tiempoTranscurrido % (1000 * 60 * 60)) / (1000 * 60));
    
    return { dias, horas, minutos, totalHoras: tiempoTranscurrido / (1000 * 60 * 60) };
  }

  //badgets
  const obtenerBadgePrioridad = (fechaEntrega) => {
    const prioridad = calcularPrioridad(fechaEntrega);
    
    const estilos = {
      urgente: 'bg-red-100 text-red-800 border-red-200',
      medio: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      normal: 'bg-green-100 text-green-800 border-green-200',
      vencida: 'bg-gray-100 text-gray-800 border-gray-200'
    };

    const iconos = {
      urgente: '🚨',
      medio: '⏰',
      normal: '✅',
      vencida: '⏰'
    };

    return (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${estilos[prioridad.tipo]}`}>
        {iconos[prioridad.tipo]} {prioridad.label}
      </span>
    );
  };
  const obtenerBadgeDisponibilidad = (solicitud) => {
      const estado = obtenerEstadoDisponibilidad(solicitud);
      
      if (estado === 'disponible') {
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800 border border-green-200">
            <CheckSquare size={12} className="mr-1" />
            Disponible
          </span>
        );
      } else if (estado === 'a_pasar_precio') {
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-orange-100 text-orange-800 border border-orange-200">
            <DollarSign size={12} className="mr-1" />
            A Pasar Precio
          </span>
        );
      } else {
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-800 border border-blue-200">
            <Hourglass size={12} className="mr-1" />
            Esperando
          </span>
        );
      }
    };

  //Ver detalles de solicitud
  const handleVerDetalles = (solicitud) => {
    // Navegar a detalles de solicitud
    navigate(`/dashboard/detalle_solicitud/${solicitud.nombreEmpresa}/${solicitud.id}`);
  };

  const handleCambiarEstado = async(value) =>{
    //actualizar solicitud
    const estadosQueRequierenPrecio = ['ESPERANDO', 'A PAGAR'];

    const requierePrecio = estadosQueRequierenPrecio.includes(value);
    const tienePrecio = solicitud.precioCobradoCliente > 0;

    if(requierePrecio && !tienePrecio) {

      showPrompt(
        "Para cambiar a este estado, debes ingresar el precio cobrado:",
        async (precioIngresado) => {
          // Guardamos el precio primero
          await actualizarSolicitud(solicitud.id, solicitud.nombreEmpresa, 'precioCobradoCliente', precioIngresado, 'field');
          // Luego cambiamos el estado
          await actualizarSolicitud(solicitud.id,solicitud.nombreEmpresa,'Estado',value,'field');
        },
        "Precio del Servicio"
      );
    } else {

      //ya contamos con precio, procedemos
      await actualizarSolicitud(solicitud.id,solicitud.nombreEmpresa,'Estado',value,'field');
    
    }

  }

  const actualizarSolicitudLocal = async(field,value) =>{
    await actualizarSolicitud(solicitud.id,solicitud.nombreEmpresa,field,value,'field');
  }

  //para tutores, calculamos dias restantes
  const calcularDiasRestantes = (fechaEntrega) => {
    if (!fechaEntrega) return 0;
      const hoy = new Date();
      const entrega = new Date(fechaEntrega);
      const diferencia = entrega - hoy;
      return Math.ceil(diferencia / (1000 * 60 * 60 * 24));
  };
  const diasRestantes = calcularDiasRestantes(solicitud.fechaentrega);
    // Función para calcular y formatear el tiempo restante
  const calcularTiempoRestante = (fechaEntrega) => {
      try {
        const ahora = new Date();
        const entrega = new Date(fechaEntrega);
        
        // Diferencia en milisegundos
        const diferencia = entrega - ahora;
        
        // Si la fecha ya pasó
        if (diferencia < 0) {
          return { valor: 'Vencido', clase: 'bg-red-500 text-white' };
        }
        
        // Convertir a horas
        const horasRestantes = Math.floor(diferencia / (1000 * 60 * 60));
        
        // Si es menos de 24 horas, mostrar en horas
        if (horasRestantes < 24) {
          return { 
            valor: `${horasRestantes} horas`, 
            clase: 'bg-red-100 text-red-800'
          };
        }
        
        // Convertir a días
        const diasRestantes = Math.ceil(diferencia / (1000 * 60 * 60 * 24));
        
        // Determinar la clase según urgencia
        let clase = 'bg-green-100 text-green-800'; // Por defecto (más de 7 días)
        
        if (diasRestantes <= 2) {
          clase = 'bg-red-100 text-red-800'; // Urgente (2 días o menos)
        } else if (diasRestantes <= 7) {
          clase = 'bg-blue-100 text-blue-800'; // Próximo (entre 3 y 7 días)
        }
        
        return { valor: `${diasRestantes} días`, clase };
      } catch (error) {
        console.error('Error al calcular tiempo restante:', error);
        return { valor: 'Fecha inválida', clase: 'bg-gray-100 text-gray-800' };
      }
    };
  const tiempoRestante = calcularTiempoRestante(solicitud.fechaentrega || solicitud.fechaEntrega);


  const infoServicio = obtenerInfoServicio(solicitud.Servicio);
  const infoCotizacion = obtenerInfoCotizaciones(solicitud.cotizaciones);
  const tiempoTranscurrido = formatearTiempoTranscurrido(solicitud.fechasistema);

  const getServicioStyles = () => {
    const servicioLower = (solicitud.Servicio || '').toLowerCase();

    switch (servicioLower){
      case 'taller':
        return{
          headerBg: 'bg-gradient-to-r from-blue-600 to-blue-800',
          icon: (
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
            </svg>
          ),
          additionalInfo: (
            <>
              <div className="mt-2 p-2 bg-purple-50 rounded-md">
                <h4 className="font-semibold text-purple-700">Detalles del Taller</h4>
                <p className="text-sm text-gray-600">
                  { `${solicitud.resumen}`}
                </p>
                <p className="text-sm text-gray-600">
                {solicitud.objetoFaltante && solicitud.objetoFaltante.formatoEntrega 
                  ? `Formato de entrega: ${solicitud.objetoFaltante.formatoEntrega}` 
                  : 'Formato de entrega no definido'}
              </p>
                
              </div>
            </>
          )
        }

      case 'tesis':
        return{
          headerBg: 'bg-gradient-to-r from-green-600 to-green-800',
          icon: (
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          ),
          additionalInfo: (
            <>
              <div className="mt-2 p-2 bg-green-50 rounded-md">
                <h4 className="font-semibold text-green-700">Información de Tesis</h4>
                <p className="text-sm text-gray-600">
                  {`Tema tesis: ${solicitud.objetoFaltante?.temaTesis}`}
                </p>
                <p className="text-sm text-gray-600">
                  {`Carrera: ${solicitud.objetoFaltante?.carrera}`}
                </p>
                <p className="text-sm text-gray-600">
                  {`Universidad: ${solicitud.objetoFaltante?.universidad}`}
                </p>
                <p className="text-sm text-gray-600">
                  {`Cantidad paginas: ${solicitud.objetoFaltante?.cantidadPaginas}`}
                </p>
                <p className="text-sm text-gray-600">
                  {`Normas de citacion: ${solicitud.objetoFaltante?.normasCitacion}`}
                </p>
                
              </div>
            </>
          )
        }

      case 'parcial':
      case 'quiz':
        const isQuiz = servicioLower === 'quiz';

        return {
          headerBg: isQuiz 
            ? 'bg-gradient-to-r from-pink-500 to-pink-700' 
            : 'bg-gradient-to-r from-indigo-600 to-indigo-800',
          icon: (
            <svg 
              className="w-5 h-5 mr-2" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              {isQuiz 
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
              }
            </svg>
          ),
          additionalInfo: (
            <>
              <div className={`mt-2 p-2 ${isQuiz ? 'bg-pink-50' : 'bg-indigo-50'} rounded-md`}>
                <h4 className={`font-semibold ${isQuiz ? 'text-pink-700' : 'text-indigo-700'}`}>
                  {isQuiz ? 'Detalles del Quiz' : 'Detalles del Parcial'}
                </h4>
                
                <p className="text-sm text-gray-600">
                  {isQuiz 
                    ? (`Temas de quiz: ${solicitud.objetoFaltante?.temasExamen}`)
                    : (`Temas de examen: ${solicitud.objetoFaltante?.temasExamen}`)
                  }
                </p>
                
                <p className="text-sm text-gray-600">
                  {isQuiz 
                    ? (`Duración examen: ${solicitud.objetoFaltante?.duracionExamen}`)
                    : (`Duración de quiz: ${solicitud.objetoFaltante?.duracionExamen}`)
                  }
                </p>
              </div>
            </>
          )
        };

      case 'clases personalizadas':
        return {
          headerBg: 'bg-gradient-to-r from-yellow-500 to-yellow-700',
          icon: (
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 14l9-5-9-5-9 5 9 5z" />
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
            </svg>
          ),
          additionalInfo: (
            <>
              <div className="mt-2 p-2 bg-yellow-50 rounded-md">
                <h4 className="font-semibold text-yellow-700">Detalles de Clases</h4>
                <p className="text-sm text-gray-600">
                  {`Temas de Asesoria: ${solicitud.resumen}`}
                </p>
                <p className="text-sm text-gray-600">
                  {`Horas de Asesoria: ${solicitud.objetoFaltante.numeroHoras}`}
                </p>
              </div>
            </>
          )
        };

      default:
        return{
          headerBg: 'bg-gradient-to-r from-blue-600 to-blue-800',
          icon: null,
          additionalInfo: null
        }
    }
  }
  const servicioInfo = getServicioStyles();

  //FUNCIONES
  //COTIZAR SOLICITUD
  const cotizarSolicitud = (solicitud) => {
    GeneralRoutes.irADetalle(navigate, solicitud);
  }
  //RECHZAR SOLICITUD
  

  return (
    <div
      key={solicitud.id}
      className={`rounded-lg p-4 shadow-md hover:shadow-lg transition-all duration-200 ${
        solicitud.ultimoIntentoSolicitud
          ? 'bg-red-50 border-2 border-red-500 hover:border-red-600 shadow-xl shadow-red-300/50' // MÁS VISIBLE
          : 'bg-white border border-gray-100 hover:border-blue-200' // Normal
      }`}
    >

      {/* Header compacto */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className={`p-1.5 rounded-lg bg-gradient-to-br ${infoServicio.color} text-white`}>
            {React.cloneElement(infoServicio.icon, { size: 16 })}
          </div>
          <div>
            <h3 className="font-bold text-gray-900 text-sm">#{solicitud.id}</h3>
            <p className="text-xs text-gray-600">{infoServicio.label}</p>
          </div>
        </div>
        
        <div className="relative flex flex-col items-end gap-1">

          {/* Menú pequeño y tiempo */}
          {isAdmin && (
            <div className="relative" ref={menuRef}>
            {/* Botón para abrir menú */}
            <button
              onClick={() => setMenuAbierto(menuAbierto === solicitud.id ? null : solicitud.id)}
              className="p-1 hover:bg-gray-100 rounded"
            >
              ⋮
            </button>

            {/* Menú */}
            {menuAbierto === solicitud.id && (
              <div className="absolute right-0 top-8 w-36 bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-hidden">
                
                <button
                  onClick={() => {
                    handleCambiarEstado('DISPONIBLE');
                    setMenuAbierto(null);
                  }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-green-50 text-green-700"
                >
                  ✓ DISPONIBLE
                </button>
                
                <button
                  onClick={() => {
                    handleCambiarEstado('EXPIRADO');
                    setMenuAbierto(null);
                  }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-red-50 text-red-700"
                >
                  ✗ EXPIRADO
                </button>
                
                <button
                  onClick={() => {
                    handleCambiarEstado('ESPERANDO');
                    setMenuAbierto(null);
                  }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-yellow-50 text-yellow-700"
                >
                  ⏳ ESPERANDO
                </button>

                <button
                  onClick={() => {
                    handleCambiarEstado('A PAGAR');
                    setMenuAbierto(null);
                  }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-yellow-50 text-yellow-700"
                >
                  ✅ A PAGAR
                </button>
                
                <button
                  onClick={() => {
                    handleCambiarEstado('NO PODEMOS');
                    setMenuAbierto(null);
                  }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-gray-50 text-gray-700"
                >
                  ❌ NO PODEMOS
                </button>

                <div className="border-t border-gray-100"></div>

                <button
                  onClick={() => {
                    enviarNotificacionSolciitud(solicitud);
                    setMenuAbierto(null);
                  }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-blue-50 flex items-center gap-2"
                >
                  <Eye size={12} className="text-blue-600" />
                  Notificar
                </button>

                <div className="border-t border-gray-100"></div>
                <button
                  onClick={() => {
                    actualizarSolicitudLocal('ultimoIntentoSolicitud',true);
                    setMenuAbierto(null);
                  }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-blue-50 flex items-center gap-2"
                >
                  <Eye size={12} className="text-blue-600" />
                  Ult Intento 🦉
                </button>
                
              </div>
            )}
            </div>
          )}

          {/* --- Contenido de la Derecha (Tiempo) --- TUTOR */}
          {isTutor && (
            <div className={`ml-4 flex-shrink-0 rounded-full px-3 py-1 text-xs font-medium ${tiempoRestante.clase}`}>
              {tiempoRestante.valor}
            </div>
          )}
          
        </div>
      </div>

      {/* Ultimo Intneto Solcitud*/}
      {solicitud.ultimoIntentoSolicitud && (
        <div className="bg-red-100 border border-red-200 rounded-md p-2 mb-3 animate-pulse">
          <p className="text-xs text-red-700 font-bold flex items-center gap-1 justify-center">
            <span>🦉</span>
            COTIZANDO EN ÚLTIMAS INSTANCIAS...
          </p>
        </div>
      )}

      {/* Vista dinamica */}
      <div className="mt-4 pt-4 border-t border-gray-100 space-y-3">

          {/* Materia - más compacta */}
          <div className="mb-3">
            <h4 className="text-sm font-bold text-gray-900 leading-tight line-clamp-2">
              {/* Si es tutor/admin y hay una predicción diferente, mostramos ambos. Si no, solo la materia. */}
              {(isTutor || isAdmin) && solicitud.materia !== solicitud.predicionesIA.materiaIA
                ? `${solicitud.materia} - ${solicitud.predicionesIA.materiaIA}`
                : solicitud.materia}
            </h4>
          </div>

          {/* Fecha de entrega */}
          <div className="mb-3">
            <div className="bg-orange-100 text-orange-700 px-2 py-1 rounded-md text-xs font-medium flex items-center gap-1">
              <Calendar size={12} />
              {formatearFechaCompleta(solicitud.fechaentrega)}
            </div>
            {isTutor && (
              <div>
                <span className="text-gray-500">Empresa:</span>
                <p className="font-medium">{solicitud.nombreEmpresa}</p>
              </div>
            )}
            
          </div>

        {isAdmin && (
          <div >
            
            {/* Cotizaciones */}
            <div className="mb-3">
              {solicitud.cotizaciones?.some(cotizacion => cotizacion.cotizacion > 0) ? (
                <div className="bg-green-100 text-green-700 px-2 py-1 rounded-md text-xs font-medium flex items-center gap-1">
                  <DollarSign size={12} />
                  {infoCotizacion.rango}
                </div>
              ) : (
                <div className="bg-gray-100 text-gray-500 px-2 py-1 rounded-md text-xs flex items-center gap-1">
                  <AlertCircle size={12} />
                  Sin cotizaciones disponibles
                </div>
              )}
            </div>

            {/* Badges compactos */}
            <div className="mb-3 flex items-center gap-1 flex-wrap">
              {obtenerBadgePrioridad(solicitud.fechaentrega)}
              {obtenerBadgeDisponibilidad(solicitud)}
            </div>

            {/* Información adicional compacta */}
            <div className="space-y-1 mb-3">

            {/* Información de tutores con iconos bonitos */}
            <div className="mb-3">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-xs text-gray-500 font-medium">Estado:</span>
                  {solicitud.Estado}
                  <div className="flex items-center gap-3">
                    {/* Tutores que han visto */}
                    <div className="flex items-center gap-1">
                      <div className="p-1 bg-blue-100 rounded-full">
                        <Eye size={10} className="text-blue-600" />
                      </div>
                      <span className="text-xs font-medium text-blue-700">
                        {solicitud.tutorVistaSolicitud.length}
                      </span>
                    </div>
                    
                    {/* Tutores que han rechazado */}
                    <div className="flex items-center gap-1">
                      <div className="p-1 bg-red-100 rounded-full">
                        <X size={10} className="text-red-600" />
                      </div>
                      <span className="text-xs font-medium text-red-700">
                        {solicitud.cotizaciones?.filter(cotizacion => cotizacion.cotizacion <= 0).length || 0}
                      </span>
                    </div>
                    
                    {/* Tutores que han cotizado */}
                    <div className="flex items-center gap-1">
                      <div className="p-1 bg-green-100 rounded-full">
                        <DollarSign size={10} className="text-green-600" />
                      </div>
                      <span className="text-xs font-medium text-green-700">
                        {solicitud.cotizaciones?.filter(cotizacion => cotizacion.cotizacion > 0).length || 0}
                      </span>
                    </div>
                  </div>
                </div>
            </div>

            {/* Preguntas */}
            {(() => {
              const preguntasSinResolver = solicitud.preguntas.filter(pregunta => 
                pregunta.respuesta.length == 0
              );
              
                return preguntasSinResolver.length > 0 ? (
                  <div className="mb-3">
                    <div className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded-md text-xs font-medium flex items-center gap-1">
                      <HelpCircle size={12} />
                      <span>
                        {preguntasSinResolver.length} pregunta{preguntasSinResolver.length !== 1 ? 's' : ''} sin resolver
                      </span>
                    </div>
                  </div>
                ) : null;
            })()}

            {/* Errores */}
            {(() => {
                const numErrores = solicitud.errores?.length || 0;
                
                return numErrores > 0 ? (
                  <div className="mb-3 animate-pulse"> {/* Agregué un pulso suave para llamar la atención */}
                    <div className="bg-red-100 text-red-700 border border-red-200 px-2 py-1 rounded-md text-xs font-bold flex items-center gap-1 shadow-sm">
                      <HelpCircle size={14} className="text-red-600" />
                      <span>
                        {numErrores} ERROR{numErrores !== 1 ? 'ES' : ''} DETECTADO{numErrores !== 1 ? 'S' : ''}
                      </span>
                    </div>
                  </div>
                ) : null;
            })()}

            {/* Info del cliente */}
            <div className="flex items-center justify-between text-xs">
                <span className="text-gray-500 flex items-center gap-1">
                  <User size={10} />
                  Cliente:
                </span>
                <span className="font-medium text-gray-700 truncate ml-2">
                  {solicitud.cliente || 'Sin asignar'}
                </span>
            </div>

            </div>

            {/* Especiales para tesis*/}
            {solicitud.Servicio == "TESIS" && (
              <>
                <BotonGenerarCotizacion
                  solicitud={solicitud}
                />
              </>
            )}

            {/* Botones compactos */}
            <div className="flex gap-2">
              <BotonCopiar
                funcionGenerarTexto={() => procesarMensajeSolicitud(solicitud, configuracion)}
                identificador={`solicitud-${solicitud.id}`}
                className="flex-1"
              />
              <button
                onClick={() => 
                  handleVerDetalles(solicitud)
                }
                className="flex-1 bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 text-xs font-medium"
              >
                <Eye size={12} />
                Ver Detalles
              </button>
            </div>

            {/* Procedencia */}
            is chatwoo o no? 🌤️

          </div>
        )}

        {isTutor && (
          <div className="space-y-3">

              {servicioInfo.additionalInfo} 

              {/* Estado */}
              <div className="mb-4">
                <div className="flex items-center">
                  <div className="h-2.5 w-2.5 rounded-full bg-blue-500 mr-2"></div>
                  <span className="text-blue-600 font-medium">
                    {solicitud.estado || 'Cotización pendiente'}
                  </span>
                </div>
              </div>

              {/* Cotizar y rechazar solicitud */}
              {/* Botones de acción */}
              <div className="flex space-x-2">
                <button
                  onClick={() => cotizarSolicitud(solicitud)}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition flex items-center justify-center"
                >
                  <svg 
                    className="w-4 h-4 mr-2" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth="2" 
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Cotizar
                </button>
                <button
                  onClick={() => onRechazar(solicitud)}
                  className="px-4 py-2 border border-red-500 text-red-500 hover:bg-red-50 rounded transition"
                >
                  Rechazar
                </button>
              </div>

          </div>
        )}

        {isCliente && (
          <div className="space-y-3 w-full"> {/* Aseguramos que el contenedor use todo el ancho */}

          {servicioInfo.additionalInfo} 

          {/* Botón de cotizar ocupando todo el ancho */}
          <button
            onClick={() => cotizarSolicitud(solicitud)}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition flex items-center justify-center"
          >
            <svg 
              className="w-4 h-4 mr-2" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth="2" 
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Ver Detalles
          </button>

        </div>
        )}


      </div>

      

      

      

      
      
      

      

      

      

    </div>
  )
  
}

export default CardSolicitud
